// @flow

type RecipePin = {
  rich_metadata?: {
    recipe?: { name: string, categorized_ingredients: mixed, from_aggregated_data: mixed },
  },
};

export function isRecipe(pin: ?RecipePin): boolean {
  return !!(
    pin &&
    pin.rich_metadata &&
    pin.rich_metadata.recipe &&
    pin.rich_metadata.recipe.name &&
    // There is a known issue with the rich metadata parsers that sometimes cause whitespace names.
    // https://jira.pinadmin.com/browse/DI-24
    pin.rich_metadata.recipe.name.trim().length > 0 &&
    pin.rich_metadata.recipe.categorized_ingredients &&
    !pin.rich_metadata.recipe.from_aggregated_data
  );
}

export default undefined;
